import { useRouteBodyCanRelease } from "@-/dev.improve.haniverse.lib.navigation.route-body-state";
import { useLayoutEffect, type ReactNode } from "react";

/** The presentation/controller survives; only its expensive rendered faces are retired. */
export function LearnReviewViewLifetime({
  canRetire,
  children,
  isActive,
  onRelease,
}: {
  canRetire: boolean;
  children: ReactNode;
  isActive: boolean;
  onRelease: () => void;
}) {
  const canRelease = useRouteBodyCanRelease();
  const isRendered = isActive || !canRetire || !canRelease;
  useLayoutEffect(() => {
    if (!isRendered) {
      onRelease();
    }
  }, [isRendered, onRelease]);
  return isRendered ? children : null;
}
